module.exports = __webpack_public_path__ + "static/img/partner-cmc.051381e7.png";